var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-overlay',[_c('div',{staticClass:"pt-10"},[_c('el-empty',{attrs:{"image-size":600,"description":"无效链接"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }